import React from 'react';
import styles from './index.module.scss';

interface PrivacyPanelProps {
  html?: string;
}

export const PrivacyPanel: React.FC<PrivacyPanelProps> = ({ html }) => (
  <div
    className={styles.PrivacyPanelContent}
    dangerouslySetInnerHTML={{ __html: html || '' }}
  />
);
